import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from 'opensolar-ui'
import { FC } from 'react'
import { useTranslate } from 'react-admin'

interface ExpoStandResource {
  id: number
  title: string
}

interface PropTypes {
  resource: ExpoStandResource | null
  onClose: () => void
  onConfirm: () => void
}

const DeleteExpoStandResourceDialog: FC<PropTypes> = ({ resource, onClose, onConfirm }) => {
  const translate = useTranslate()

  return (
    <Dialog open={Boolean(resource)} onClose={onClose}>
      <DialogTitle>{translate('Delete resource')}</DialogTitle>
      <DialogContent>
        <Typography>
          {translate('Are you sure you want to delete "%{title}"? This cannot be undone.', {
            title: resource?.title || '',
          })}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{translate('Cancel')}</Button>
        <Button color="secondary" onClick={onConfirm}>
          {translate('Delete')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DeleteExpoStandResourceDialog
